import apiConfig from "constants/apiConfig";
import axiosClient from "utils/axiosClient";

export const fetchDashboardFeatures = async (agencyId: string) => {
    const response = await axiosClient.get(apiConfig.FETCH_DASHBOARD_FEATURES.url.replace('<agencyId>', agencyId));
    return response.data;
}